import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

// 审批中心一级
const userRouter: RouteConfig = {
  path: '/approval',
  component: Layout,
  redirect: '/approval/my-approval/approval-list',
  meta: {
    title: '审批',
    icon: 'menu-approve',
    alwaysShowMenu: true
  },
  children: [
    {
      name: 'MyApproval',
      path: 'my-approval',
      component: () => import('@/views/approval/my-approval/index.vue'),
      redirect: '/approval/my-approval/approval-list',
      meta: {
        title: '待我审批'
      },
      children: [
        {
          name: 'ApprovalList',
          path: 'approval-list',
          component: () => import('@/views/approval/my-approval/approval-list.vue'),
          meta: {
            title: '我的审核'
          }
        }
      ]
    }
  ]
}

export default userRouter
